import React from "react";
import { Button } from "../../UI/Button";
import { UserMembershipRemovalModal } from "../UserMembershipRemovalModal";
import { useModalContext } from "../../contexts/ModalContext/context";
import useAuth from "../../routes/login/AuthContext";

export interface IProps {
  name: string;
  id: string;
  label?: string;
  onSuccess?: VoidFunction;
}

export const UserMembershipRemoveButton: React.FC<IProps> = (props) => {
  const { setIsOpen } = useModalContext();
  const { isSuperAdminRead } = useAuth();

  const handleRemoveClick = () => {
    setIsOpen(true);
  };

  return (
    <>
      <Button appearance="danger" onClick={handleRemoveClick} isDisabled={isSuperAdminRead()}>
        {props.label}
      </Button>
      <UserMembershipRemovalModal name={props.name} userId={props.id} onSuccess={props.onSuccess} />
    </>
  );
};

UserMembershipRemoveButton.defaultProps = {
  label: "Remove",
};
